import React from 'react';
import { Columns, Column } from 'src/ui/mui-ui-kit';
import { Field } from 'react-final-form';
import {
  UiInputAdapter,
  UiFieldset,
  UiToggleAdapter,
  UiDatePickerAdapter,
} from 'src/ui';
import { composeValidators, required } from 'src/ui/validations';
import { cleanseInt, cleanseDecimal } from 'src/ui/util';
import propTypes from 'prop-types';
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export function CardProcessingForm({ form }) {
  return (
    <>
      <UiFieldset title="Card Processing" isFirst>
        <Columns isMultiline>
          <Column isSize="1/2">
            {' '}
            <Field
              component={UiToggleAdapter}
              id="acceptedCardBefore"
              name="acceptedCardVefore"
              type="checkbox"
            >
              Accepted Card Before?
            </Field>
          </Column>
          <Column isSize="1/2">
            <Field
              component={UiInputAdapter}
              name="processorName"
              id="processorName"
              label="Processor Name"
            />
          </Column>
          <Column isSize="1/2">
            <Field
              component={UiToggleAdapter}
              id="priorTerminations"
              name="priorTerminations"
              type="checkbox"
            >
              Prior Terminations?
            </Field>
          </Column>
          <Column isSize="1/2">
            <Field
              component={UiInputAdapter}
              name="priorTerminationsExplanation"
              id="priorTerminationsExplanation"
              label="If Prior Terminations, Please Explain"
            />
          </Column>
          <Column isSize="1/2">
            <Field
              component={UiDatePickerAdapter}
              name="processingStartDate"
              id="processingStartDate"
              label="Estimated Processing Start Date"
              required
              minDate={dayjs()
                .startOf('day')
                .toDate()}
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              hasIcons="right"
              renderIcons={() => [
                <span className="icon is-right" key="right-icon">
                  <FontAwesomeIcon icon={['fal', 'calendar-alt']} />
                </span>,
              ]}
              validate={composeValidators(
                'Estimated Processing Start Date',
                required
              )}
            />
          </Column>
          <Column isSize="1/2">
            <Field
              component={UiInputAdapter}
              name="numberOfLocations"
              id="numberOfLocations"
              required
              label="Number of Locations"
              validate={composeValidators('Number of Locations', required)}
              onChange={e => form.mutators.cleanse(e, cleanseInt)}
            />
          </Column>
          <Column isSize="1/2">
            <Field
              component={UiInputAdapter}
              id="existingMid"
              name="existingMid"
              label="Existing MID"
            />
          </Column>
          <Column isSize="1/2">
            <Field
              component={UiInputAdapter}
              id="annualVolume"
              name="annualVolume"
              label="Annual Volume $"
              required
              onChange={e => form.mutators.cleanse(e, cleanseDecimal)}
              validate={composeValidators('Annual Volume $', required)}
            />
          </Column>
          <Column isSize="1/2">
            <Field
              component={UiInputAdapter}
              id="monthlyVolume"
              name="monthlyVolume"
              label="Monthly Volume $"
              onChange={e => form.mutators.cleanse(e, cleanseDecimal)}
              required
              validate={composeValidators('Monthly Volume $', required)}
            />
          </Column>
          <Column isSize="1/2">
            <Field
              component={UiInputAdapter}
              id="avgTicket"
              name="avgTicket"
              label="Average Ticket $"
              onChange={e => form.mutators.cleanse(e, cleanseDecimal)}
              required
              validate={composeValidators('Average Ticket $', required)}
            />
          </Column>
          <Column isSize="1/2">
            <Field
              component={UiInputAdapter}
              id="highTicket"
              name="highTicket"
              label="High Ticket $"
              onChange={e => form.mutators.cleanse(e, cleanseDecimal)}
              required
              validate={composeValidators('High Ticket $', required)}
            />
          </Column>
        </Columns>
      </UiFieldset>
    </>
  );
}

CardProcessingForm.propTypes = {
  form: propTypes.object.isRequired,
};
